import {InMemoryCache, defaultDataIdFromObject, ApolloClient, HttpLink} from '@apollo/client';
import type {IncomingMessage, ServerResponse} from 'http';

import {skipNulls, fetchWithProgress} from '../components/utils';

const GRAPHQL_ENDPOINT = process.env.API_URL;
const SSR_TIMEOUT = 5000;

export type ApolloConfig = Omit<ApolloClient.Options, 'cache' | 'defaultOptions'> & {createCache: any};

export type Context = {
	req: IncomingMessage & {span?: any};
	res: ServerResponse;
};

const isBrowser = typeof window !== 'undefined';

/** на сервере запрос не должен висеть дольше таймаута, иначе рендер страницы встанет */
const fetchWithTimeout: typeof fetch = (input, init) =>
	fetch(input, {...init, signal: init?.signal ?? AbortSignal.timeout(SSR_TIMEOUT)});

export const apolloConfigFn = (ctx?: null | Context): ApolloConfig => {
	const headers: Record<string, any> = {};
	const req = ctx && ctx.req;

	if (!isBrowser && req) {
		/* проброс IP клиента */
		headers['x-forwarded-for'] = req.headers['x-forwarded-for'] || req.socket?.remoteAddress;
		/* куки */
		headers.cookie = req.headers.cookie;
		/* заголовок юзерагента */
		headers['user-agent'] = req.headers['user-agent'];
		/* заголовок реферера */
		headers.referer = req.headers.referer;
	}

	const link = new HttpLink({
		fetch: (isBrowser ? fetchWithProgress : fetchWithTimeout) as any,
		uri: GRAPHQL_ENDPOINT,
		headers: skipNulls(headers),
		fetchOptions: {
			credentials: 'same-origin',
		},
	});

	return {
		link,
		createCache() {
			return new InMemoryCache({
				resultCaching: isBrowser,
				dataIdFromObject: (object: any) => {
					// Результаты поиска не нормализуем: id у них уникален только внутри своей сущности —
					// у заклинания и статьи глоссария «Телепатия» он одинаковый, и в кеше они склеились бы
					// в одну запись, а в выдаче одна и та же строка появлялась бы дважды
					if (object.__typename === 'SearchHit') return false;
					if (object.id) {
						return object.__typename + ':' + object.id;
					}
					return defaultDataIdFromObject(object); // fall back to default handling
				},
			});
		},
	};
};
